export class MysteryShopperCreateUpdateRequest {
    body: MysteryShopperCreateUpdateBody = new MysteryShopperCreateUpdateBody();
}

/* ---------------------------------- */
/* Body */
/* ---------------------------------- */
export class MysteryShopperCreateUpdateBody {
    ProcessName: string = 'DC Community Portal SR Process Wrapper WF';
    DCMethod: string = 'SAVEASDRAFT'; // CREATE / UPDATE
    DCLoginName: string = '';
    DCLanguage: string = 'ENU';
    DCIncomingHierarchy: MysteryShopperCreateUpdateDCIncomingHierarchy =
        new MysteryShopperCreateUpdateDCIncomingHierarchy();
}

/* ---------------------------------- */
/* Incoming Hierarchy */
/* ---------------------------------- */
export class MysteryShopperCreateUpdateDCIncomingHierarchy {
    MessageId: string = '';
    IntObjectName: string = 'DC Community Portal SR Upsert IO';
    MessageType: string = 'Integration Object';
    IntObjectFormat: string = 'Siebel Hierarchical';
    'ListOfDC Community Portal SR Upsert IO':
        MysteryShopperListOfDCCommunityPortalSRUpsertIO =
        new MysteryShopperListOfDCCommunityPortalSRUpsertIO();
}

/* ---------------------------------- */
/* SR Upsert IO */
/* ---------------------------------- */
export class MysteryShopperListOfDCCommunityPortalSRUpsertIO {
    'DC Community Portal SR': MysteryShopperDCCommunityPortalSRUpsert =
        new MysteryShopperDCCommunityPortalSRUpsert();
}

/* ---------------------------------- */
/* SR Core */
/* ---------------------------------- */
export class MysteryShopperDCCommunityPortalSRUpsert {
    'SR Number': string = '';
    CSN: string = '';
    'SR Type': string = 'Service Excellence Programme';
    'Sub Type': string = 'Mystery Shopper Membership';
    'DC Payment Method': string = 'Online';
    'DC Channel': string = 'Online';

    'ListOfDC Community Portal Mem Pack Details':
        MysteryShopperListOfMemPackDetails =
        new MysteryShopperListOfMemPackDetails();

    'ListOfDC Community Portal SR Notes':
        MysteryShopperListOfSRNotes =
        new MysteryShopperListOfSRNotes();
}

/* ---------------------------------- */
/* Package Details */
/* ---------------------------------- */
export class MysteryShopperListOfMemPackDetails {
    'DC Community Portal Mem Pack Details':
        MysteryShopperMemPackDetails[] = [];
}

export class MysteryShopperMemPackDetails {
    'DC Package Type': string = '';
    'DC No of Branch': string = '';
    'DC No of eChannels': string = '';
    'DC Unit Price': string = '';
    'DC VAT Amt': string = '';
    'DC Total Amt': string = '';
    'DC Total VAT Amt': string = '';

    'ListOfDC Community Portal Mem Pack Details_QuarterMvl':
        MysteryShopperListOfQuarterMvl =
        new MysteryShopperListOfQuarterMvl();
}

/* ---------------------------------- */
/* Package Quarters */
/* ---------------------------------- */
export class MysteryShopperListOfQuarterMvl {
    'DC Community Portal Mem Pack Details_QuarterMvl':
        MysteryShopperQuarterMvl[] = [];
}

export class MysteryShopperQuarterMvl {
    'DC Quarter': string = '';
}

/* ---------------------------------- */
/* SR Notes */
/* ---------------------------------- */
export class MysteryShopperListOfSRNotes {
    'DC Community Portal SR Notes': MysteryShopperSRNote[] = [];
}

export class MysteryShopperSRNote {
    Note: string = '';
    'Note Type': string = 'Note to Agent';
}
